import { BaseSearchResult, SearchResult } from '@lumapps/search/types';

/** Makes sure that the given search result has a metadata field, in order to determine the documentType */
export const isBaseSearchResult = (result: SearchResult): result is BaseSearchResult => 'metadata' in result;
